const FeedVideo = ({
  video,
  isShown,
}: {
  video: string
  isShown?: boolean
}) => {
  if (!isShown) {
    return (
      <div
        className="flex overflow-hidden relative justify-center items-center w-full bg-black"
        style={{ paddingTop: "100%" }}
      >
        <div className="text-center text-white">
          <p>Loading video...</p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="overflow-hidden relative w-full bg-black"
      style={{ paddingTop: "100%" }}
    >
      <video
        src={video}
        className="absolute top-0 left-0 w-full h-full border-none"
        controls
        autoPlay
        playsInline
        // 필요시 muted, loop 등 추가
        title="Feed Video"
      />
    </div>
  )
}

export default FeedVideo
